<template>
  <Layout>
    <h2 class="py-4">{{ formTitle }}</h2>
    <div class="w-full lg:w-1/2 pt-4">
      <p class="pb-4">Name</p>
      <pt-form-input
        id="name"
        v-model="name"
        class="pb-4"
        type="text"
        placeholder="Enter name..."
      />
      <p class="pb-4">Code</p>
      <pt-form-input
        id="code"
        v-model="code"
        class="pb-4"
        type="text"
        placeholder="Enter code..."
      />
      <p class="pb-4">Description</p>
      <pt-form-input
        id="desc"
        v-model="desc"
        class="pb-4"
        type="text"
        placeholder="Enter description..."
      />
    </div>
    <h3 class="pb-8">Permissions</h3>
    <div class="w-full lg:w-1/2">
      <div class="flex flex-wrap">
        <div
          v-for="perm in permissions"
          :key="perm.id"
          class="w-1/2 lg:w-1/3 pb-4"
        >
          <input
            v-model="checkedPerms"
            :value="perm.id"
            :id="perm.id"
            type="checkbox"
          />
          <label :for="perm.id" class="pl-2">{{ perm.name }}</label>
        </div>
      </div>
    </div>
    <div class="w-1/2 lg:w-1/6">
      <pt-button
        :disabled="submitting"
        :is-full-width="true"
        variant="primary"
        class="mt-4"
        @action="submit"
      >
        {{ submitting ? 'Submitting...' : 'Submit' }}
      </pt-button>
    </div>
  </Layout>
</template>

<script>
import Layout from '@layouts/main';
import { PtButton } from '@pathao/ui-components/esm/Button';
import { PtFormInput } from '@pathao/ui-components/esm/FormComponents';
import { ADMIN_ROLE, PERMISSION_LIST } from '@src/config/apiEndpoints';
import apiRequest from '@src/utils/apiRequest';
export default {
  name: 'CreateRole',
  page: {
    title: 'Create role',
  },
  components: {
    Layout,
    PtButton,
    PtFormInput,
  },
  props: {
    roleid: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      formTitle: this.roleid ? 'Edit Role' : 'Add Role',
      name: '',
      code: '',
      desc: '',
      checkedPerms: [],
      permissions: [],
      submitting: false,
    };
  },
  created() {
    this.getPermissions();
    if (this.roleid) {
      this.getRole(this.roleid);
    }
  },
  methods: {
    submit() {
      let payload = {
        url: ADMIN_ROLE,
        method: 'POST',
        data: {
          code: this.code,
          name: this.name,
          description: this.desc,
          permissions: this.checkedPerms,
        },
      };

      if (!this.name) {
        this.$notification.warning('The name field is required!');
        return;
      }
      if (!this.code) {
        this.$notification.warning('The code field is required!');
        return;
      }

      if (this.roleid) {
        payload.url = ADMIN_ROLE + this.roleid;
      }
      this.submitting = true;
      apiRequest(payload)
        .then((response) => {
          this.submitting = false;
          this.$router.push('/roles');
        })
        .catch(() => {
          // console.log(error.response);
          this.submitting = false;
        });
    },
    getRole(roleid) {
      let payload = {
        url: ADMIN_ROLE + roleid,
        method: 'GET',
      };
      apiRequest(payload)
        .then((response) => {
          this.name = response.data.role.name;
          this.code = response.data.role.code;
          this.desc = response.data.role.description;
          let permissions = response.data.role.permissions;
          this.checkedPerms = permissions.map(perm => perm.id);
        });
    },
    getPermissions() {
      let payload = {
        url: PERMISSION_LIST,
        method: 'GET',
      };
      apiRequest(payload)
        .then((response) => {
          this.permissions = response.data.permissions;
        });
    },
  },
};
</script>
